import type { GuidedPolyMatchResult } from "./guidedPolyMatch";
/** Ventana de audio más corta = inferencia Basic Pitch en Aprender. */
export const POLY_CAPTURE_MIN_MS = 220;
export const POLY_CAPTURE_MAX_MS = 340;

/** Mínimo entre intentos de Basic Pitch (solo Aprender, voz(es) faltante(s)). */
export const LEARN_BP_MIN_INTERVAL_MS = 1100;
export const LEARN_BP_MIN_HELD_MS = 220;

export function learnPolyCaptureDurationMs(durationMs: number): number {
  const ms = Math.round(durationMs * 0.48);
  return Math.max(220, Math.min(340, ms));
}

/** Basic Pitch en Aprender: solo si faltan ≥2 voces tras buffer mono y sostenido breve. */
export function shouldTriggerLearnPolyCapture(
  eventIndices: number[],
  learnHits: Set<number>,
  heldMs: number,
  lastAttemptAt: number,
  busy: boolean
): boolean {
  if (eventIndices.length < 2 || busy) return false;
  if (heldMs < LEARN_BP_MIN_HELD_MS) return false;
  const missing = eventIndices.filter((idx) => !learnHits.has(idx)).length;
  if (missing < 2) return false;
  if (performance.now() - lastAttemptAt < LEARN_BP_MIN_INTERVAL_MS) return false;
  return true;
}

export type DetectExpectedPolyphonyFn = (opts: {
  expectedMidis: number[];
  noteIndices: number[];
  captureMs?: number;
}) => Promise<GuidedPolyMatchResult>;
